// Engine evaluation info processing

/**
 * Normalize engine evaluation info to White's perspective
 * 
 * @param {Object} info - Raw engine info object with score
 * @param {string} sideToMove - Current side to move ('w' or 'b')
 * @returns {Object|null} Normalized eval info or null if should skip
 */
export function normalizeEngineEval(info, sideToMove = 'w') {
  let percent = 0.5;
  let label = '';
  let whiteCpNormalized = null;

  if (!info || !info.score) {
    return null;
  }

  if (info.score.type === 'mate') {
    // Positive mate value means mate for the side to move; adjust to White POV.
    const mateIn = info.score.value;
    if (typeof mateIn === 'number') {
      const whiteIsMating = (mateIn > 0 && sideToMove === 'w') || (mateIn < 0 && sideToMove === 'b');
      // Ignore shallow mate blips to prevent flicker; rely on cp until stable
      if (Math.abs(mateIn) <= 2) {
        return null; // keep previous eval
      }
      percent = whiteIsMating ? 1 : 0;
      // Label with sign from White POV: +M# for White, -M# for Black
      label = `${whiteIsMating ? '+' : '-'}M${Math.abs(mateIn)}`;
      whiteCpNormalized = null;
    }
  } else if (info.score.type === 'cp') {
    let cp = info.score.value || 0;
    // Stockfish scores are from the side to move POV. Convert to White POV.
    if (sideToMove === 'b') cp = -cp;
    // Map centipawns to 0..1 using tanh
    const scaled = Math.tanh((cp || 0) / 400);
    percent = (scaled + 1) / 2; // [-1,1] -> [0,1]
    label = (cp > 0 ? '+' : '') + (cp / 100).toFixed(2);
    whiteCpNormalized = cp;
  }

  return {
    ...info,
    percent,
    label,
    whiteCp: whiteCpNormalized
  };
}

/**
 * Merge normalized eval info with previous state
 * 
 * @param {Object} prevEvalInfo - Previous eval info state
 * @param {Object} normalizedEval - Newly normalized eval info
 * @returns {Object} Merged eval info
 */
export function mergeEvalInfo(prevEvalInfo, normalizedEval) {
  if (!normalizedEval) {
    return prevEvalInfo;
  }
  return { ...(prevEvalInfo || {}), ...normalizedEval };
}






